<template>
  <div>
    <NuxtRouteAnnouncer/>
    <NuxtLoadingIndicator :color="brandColor"  />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
const brandColor = useRuntimeConfig().public.colors.brand;

useHead({
    script: import.meta.dev ? [] : [
        {
            src: "https://identity.netlify.com/v1/netlify-identity-widget.js",
            async: true
        },
    ],
});
</script>

<style>
.page-enter-active,
.page-leave-active {
    transition: opacity 0.2s;
}
.page-enter-from,
.page-leave-to {
    opacity: 0;
}
</style>